import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=97b672cc&"
import script from "./Challenges.vue?vue&type=script&lang=js&"
export * from "./Challenges.vue?vue&type=script&lang=js&"
import style0 from "./Challenges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports